import _lib from '../_lib';
import active from './active/index';
import {VaccinationNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'vaccinations';
  let activations = [
    {
      name: 'vaccinations',
      test: api.messageIs(VaccinationNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

